//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

export function useGetProcesses() {
  const getProcesses = async (params: {
    clientId?: string;
    whatsapp?: string;
  }) => {
    const { clientId, whatsapp } = params;
    const queryParams = new URLSearchParams();

    if (clientId) queryParams.append("clientId", clientId);
    if (whatsapp) queryParams.append("whatsapp", whatsapp);

    const response = await fetch(
      `${API_URL}/processes?${queryParams.toString()}`,
      {
        headers: getAuthHeaders(),
      },
    );
    return response.json();
  };

  return { getProcesses };
}
